<script lang="ts">
	import Image from '$lib/storyblok/components/image.svelte';
	import PaymentMethodMessagingElement from '$lib/stripe/paymentMethodMessagingElement.svelte';
	import ProductPrice from '../productPrice.svelte';
	import { checkoutSession } from '$lib/state/checkoutSession.svelte';
	import { shoppingCart } from '$lib/state/shoppingCart.svelte';

	let productName = $derived(
		checkoutSession.selectedProduct?.component === 'product_details' &&
			checkoutSession.selectedProduct.name?.length
			? checkoutSession.selectedProduct.name
			: checkoutSession.selectedProduct?.component === 'cart_product_addon' &&
					checkoutSession.baseProduct?.name
	);

	let priceSubline = $derived(
		checkoutSession.selectedProduct?.component === 'product_details'
			? checkoutSession.selectedProduct.description
			: checkoutSession.selectedProduct?.component === 'cart_product_addon' &&
					checkoutSession.baseProduct?.description
	);
</script>

<div class="mt-6 flex gap-x-4 lg:gap-x-6">
	<Image
		wrapperClass="bg-[#F5F5F0] shrink-0 aspect-square h-20 w-20 lg:h-28 lg:w-28 rounded-xl select-none"
		class="h-full w-full object-cover"
		src={checkoutSession.selectedProductImage.filename}
		height={600}
		width={600}
	/>
	<div>
		<div class="text-[24px]/[108%] font-semibold tracking-[-.32px] lg:text-[28px]/[110%]">
			{shoppingCart.data?.title || 'Mill Food Recycler'}
		</div>

		{#if productName}
			<p class="mt-1 text-[16px]/[150%] tracking-[-.16px] text-brown-4">
				{productName}
			</p>
		{/if}

		<div
			class="mt-1 text-[16px]/[150%] tracking-[-.16px] lg:text-[20px]/[140%] lg:tracking-[-.2px]"
		>
			<ProductPrice
				price={checkoutSession.data.product?.price.unit_amount || 99900}
				promoCode={checkoutSession.data.product?.promotionCode}
				interval={checkoutSession.data.product?.price.recurring?.interval}
			/>
		</div>
		{#if priceSubline}
			<p class="-mt-1 text-[12px]/[160%] text-brown-4 lg:text-[14px]">
				{priceSubline}
			</p>
		{/if}
		{#if shoppingCart.data?.display_affirm && checkoutSession.canUseFinancing}
			<PaymentMethodMessagingElement
				amount={checkoutSession.data.product?.price.unit_amount || 99900}
				coupon={checkoutSession.data.product?.promotionCode?.coupon}
				id="payment-method-messaging-element-cart"
				class="mt-1"
			/>
		{/if}
	</div>
</div>
